import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { AuthenticationService } from '@app/services/authentication/authentication.service';
import { ROUTE_NAMING } from '@app/constants';

@Injectable({
  providedIn: 'root'
})
export class RolesGuard implements CanActivate {

  constructor(
    private auth: AuthenticationService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (environment.activeRoles) {
      if (this.auth.user.value.roles.filter(rol => rol === 'Aliados+' || rol === 'Funcionario').length > 0) {
        return true;
      }

      this.router.navigate([ROUTE_NAMING.PRINCIPAL, ROUTE_NAMING.LANDING]);
      this.auth.preventFailReload.next(true);
      return true;
    }

    return true;
  }

}
